import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Add question", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "new-question-title",
  class: "small text-secondary text-uppercase font-weight-bold"
}, " Titre ", -1)
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("legend", { class: "d-block small text-secondary text-uppercase font-weight-bold" }, "Options", -1)
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Désordonner les choix ")
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Choix unique ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "(max. 1 choix)", -1)
const _hoisted_15 = { style: {"height":"20rem"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("legend", { class: "d-block small text-secondary text-uppercase font-weight-bold" }, "Choix", -1)
const _hoisted_17 = { class: "list-group list-group-flush" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-grip-vertical text-secondary" }, null, -1)
const _hoisted_20 = { class: "col-8" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Choix unique", -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times mt-1" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Annuler")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Confirmer")

import * as v from 'valibot';
import { ref } from 'vue';
import AppInput from './AppInput.vue';
import AppTextarea from './AppTextarea.vue';
import ChoiceAddButton from './ChoiceAddButton.vue';
import ActionDialog, { type ActionProps } from './ActionDialog.vue';
import { useAlert } from '@/composables/alert';
import Button from 'primevue/button';
import FormCheck from './FormCheck.vue';
import { type Question, QuestionSchema, type ChoicePayload, type QuestionPayload } from '@/types';
import axios from "@/api";

interface QuestionCreateProps extends ActionProps {
    ordinal: number;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}


export default /*#__PURE__*/_defineComponent({
  props: {
    ordinal: null,
    campaignId: null
  },
  emits: ["created"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'created', value: Question): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    ordinal: number;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}





const isVisible = ref(false);
const alert = useAlert();
const errors = ref<v.FlatErrors<typeof QuestionSchema>['nested']>();

function empty(): QuestionPayload {
    return {
        ordinal: props.ordinal,
        title: '',
        isSingleAnswer: false,
        isShuffledAnswers: true,
        choices: [
            {
                name: '',
                isNone: false
            },
            {
                name: '',
                isNone: false
            }
        ]
    }
}

const newQuestion = ref<QuestionPayload>(empty());

function addChoice(): void {
    newQuestion.value.choices.push({
        name: '',
        isNone: false,
    });
}

function removeChoice(index: number): void {
    if (newQuestion.value.choices.length === 2) {
        return;
    }

    newQuestion.value.choices.splice(index, 1);
}

function onQuestionSubmit(): void {
    newQuestion.value.ordinal = props.ordinal;
    errors.value = undefined;

    const payload = v.safeParse(QuestionSchema, newQuestion.value, {
        abortPipeEarly: true,
    });

    if (payload.success) {
        axios.post('/questions', {
            ...payload.output,
            brandlift: `/campaigns/brandlifts/${props.campaignId}`,
        }).then(({ data }) => {
            emit('created', data);
            alert.value = {
                status: 'success',
                summary: 'La question a été ajoutée avec succès'
            }
        }).catch(() => {
            alert.value = {
                status: 'error',
            }
        });
    } else {
        errors.value = v.flatten<typeof QuestionSchema>(payload.issues).nested;
    }
}

function onChoiceChange(choice: ChoicePayload): void {
    if (choice.name.includes('Aucun')) {
        choice.isNone = true;
    }
}

function reset() {
    alert.value = null;
    newQuestion.value = empty();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(onQuestionSubmit, ["prevent"])
  }, [
    _createVNode(_unref(Button), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => {isVisible.value = true;}),
      class: "w-100 justify-content-center p-button-text",
      style: {"border":"1px dashed"},
      "aria-haspopup": "dialog"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(ActionDialog, {
      visible: isVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((isVisible).value = $event)),
      header: "Ajouter une question",
      alert: _unref(alert),
      style: _normalizeStyle({ width: _unref(alert) ? '30rem' : '50rem' }),
      "campaign-id": __props.campaignId,
      onHide: reset
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          onClick: _cache[4] || (_cache[4] = ($event: any) => {isVisible.value = false;}),
          class: "p-button-text p-button-secondary"
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }),
        _createVNode(_unref(Button), { type: "submit" }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(AppTextarea, {
            id: "new-question-title",
            modelValue: newQuestion.value.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newQuestion.value.title) = $event)),
            "auto-resize": "",
            required: "",
            invalid: Boolean(errors.value?.['title'])
          }, null, 8, ["modelValue", "invalid"]),
          (errors.value?.['title'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errors.value['title'][0]), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("fieldset", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(FormCheck, {
                modelValue: newQuestion.value.isShuffledAnswers,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newQuestion.value.isShuffledAnswers) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(FormCheck, {
                modelValue: newQuestion.value.isSingleAnswer,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newQuestion.value.isSingleAnswer) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("fieldset", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("ul", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newQuestion.value.choices, (choice, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `new-choice-${i}`,
                class: "list-group-item"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(AppInput, {
                      modelValue: choice.name,
                      "onUpdate:modelValue": ($event: any) => ((choice.name) = $event),
                      placeholder: `Choix ${i + 1}`,
                      required: "",
                      maxlength: "45",
                      invalid: Boolean(errors.value?.[`choices.${i}.name`]),
                      onChange: ($event: any) => (onChoiceChange(choice))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "invalid", "onChange"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(FormCheck, {
                      modelValue: choice.isNone,
                      "onUpdate:modelValue": ($event: any) => ((choice.isNone) = $event),
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  (newQuestion.value.choices.length > 2)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-text col-1",
                        onClick: ($event: any) => (removeChoice(i))
                      }, _hoisted_24, 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _createVNode(ChoiceAddButton, { onClick: addChoice })
        ])
      ]),
      _: 1
    }, 8, ["visible", "alert", "style", "campaign-id"])
  ], 40, _hoisted_1))
}
}

})